






import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({ components: {} })
export default class Icon extends Vue {
  // icon 名称
  @Prop({ required: true, type: String }) name;
  @Prop({ default: "", type: String }) customClass;

  get href() {
    return `#icon-${this.name}`;
  }
}
